module.exports = __webpack_public_path__ + "img/shield.171ba61f.svg";